import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { API, EVENTS, CLASSES, cleanMobile, validate, apiError } from "@/lib/reg";
import { Field } from "./Field";

const FIELDS = [
  ["full_name", "नाम", "Name", "text"],
  ["father_name", "पिता का नाम", "Father's Name", "text"],
  ["mobile", "मोबाइल", "Mobile", "tel"],
  ["parent_mobile", "अभिभावक मोबाइल", "Parent Mobile", "tel"],
  ["dob", "जन्म तिथि", "Date of Birth", "date"],
  ["school", "स्कूल", "School", "text"],
  ["emergency_contact", "आपातकालीन नंबर", "Emergency Contact", "tel"],
];

export const EditDialog = ({ row, auth, onClose, onSaved }) => {
  const [f, setF] = useState(null);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF(row ? { ...row } : null); setErrors({}); }, [row]);
  if (!f || !row) return null;
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const toggle = (id) => set("events", f.events.includes(id) ? f.events.filter((x) => x !== id) : [...f.events, id]);

  const save = async () => {
    const errs = validate({ ...f, parent_consent: true, rules_agreement: true });
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setBusy(true);
    try {
      const body = {
        full_name: f.full_name, father_name: f.father_name || "", dob: f.dob, player_class: f.player_class, school: f.school, events: f.events,
        mobile: cleanMobile(f.mobile), parent_mobile: cleanMobile(f.parent_mobile), emergency_contact: cleanMobile(f.emergency_contact),
      };
      const { data } = await axios.put(`${API}/registrations/${row.registration_id}`, body, auth);
      toast.success("बदलाव सेव हो गए / Changes saved");
      onSaved(data);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto bg-white" data-testid="edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-hi text-navy">रिकॉर्ड बदलें · Edit {row.registration_id}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {FIELDS.map(([k, hi, en, type]) => (
            <Field key={k} label={hi} en={en} name={`edit-${k}`} error={errors[k]}>
              <input id={`edit-${k}`} type={type} value={f[k]} onChange={(e) => set(k, e.target.value)}
                className={`gp-input ${errors[k] ? "bad" : ""}`} data-testid={`edit-input-${k}`} />
            </Field>
          ))}
          <Field label="कक्षा" en="Class" name="edit-class" error={errors.player_class}>
            <select value={f.player_class} onChange={(e) => set("player_class", e.target.value)} className="gp-input" data-testid="edit-select-class">
              {CLASSES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </Field>
          <Field label="खेल" en="Events" name="edit-events" error={errors.events}>
            <div className="grid grid-cols-2 gap-2">
              {EVENTS.map((ev) => (
                <button type="button" key={ev.id} onClick={() => toggle(ev.id)} aria-pressed={f.events.includes(ev.id)}
                  className={`ev-chip ${f.events.includes(ev.id) ? "on" : ""}`} data-testid={`edit-event-${ev.id}`}>
                  <span className="font-hi font-semibold text-sm">{ev.hi}</span>
                </button>
              ))}
            </div>
          </Field>
          <div className="grid grid-cols-2 gap-3 pt-2">
            <button onClick={onClose} className="btn-outline justify-center" data-testid="edit-cancel-btn">रद्द · Cancel</button>
            <button onClick={save} disabled={busy} className="btn-saffron justify-center" data-testid="edit-save-btn">
              {busy ? <Loader2 className="animate-spin" size={18} /> : "सेव करें · Save"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
